import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from '@ui/components/layout/Toaster';
import { ConfirmProvider } from '@ui/hooks/useConfirm';
import { store } from '@ui/store';
import { useMeQuery } from '@ui/store/authApi';
import { router } from '@/router';
import './index.css';

function TitleSync() {
  const { data } = useMeQuery();
  useEffect(() => {
    if (data?.platform.appName) document.title = `Admin · ${data.platform.appName}`;
  }, [data?.platform.appName]);
  return null;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ConfirmProvider>
        <TitleSync />
        <RouterProvider router={router} />
        <Toaster />
      </ConfirmProvider>
    </Provider>
  </StrictMode>
);
